import { jsx as _jsx } from "react/jsx-runtime";
import ivclass from '../../../Modules/IVClass';
const Tag = (props) => {
    const { slug, endpoint, tagCount, textClass } = props;
    return (_jsx("span", { className: ivclass('iv-font-medium', 'iv-text-black-50', 'iv-overflow-hidden iv-overflow-ellipsis iv-whitespace-nowrap', `iv-max-w-[${300 / tagCount}px]`, 'hover:iv-cursor-default', textClass), children: `#${slug.replace(/-/g, '')}` }));
};
export default Tag;
